import { get } from 'lodash';

import { AppState } from 'Interfaces/Interfaces';

const root = (state: AppState) => get(state, 'switchStudentCartModalState');

export const getOpen = (state: AppState) => get(root(state), 'open', false);
export const getNewStudentId = (state: AppState) => get(root(state), 'newStudentId', "");
